import React from "react";

export const moedaRealLocale = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {

    let value = e.target.value;
    value = (parseFloat(value)).toLocaleString('pt-BR');
    // value = value.replace(/\D/g, "");
    // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
    // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
    // //value = (((parseFloat(value) * 100)/100)).toFixed(2).toString();  

    e.target.value = value

    return e;
}

export const moedaRealLocaleValue = (valor: string) => {
    
    if (valor === null) {
        return;
    }
    if (valor.length <= 1) {
        return valor;
    }


    let value = valor;

    if (Number(value) < 0) {
        value = (parseFloat(value)).toLocaleString('pt-BR');
        //value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        return value;
    }

    if (Number.isInteger(Number(value))) {

        value = (parseFloat(value)).toLocaleString('pt-BR');
        //value = (parseFloat(value)).toString();
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        return value;
    }
    else if (Number(value)) {
        value = value.toString().replaceAll(".", ",");
        value = (parseFloat(value)).toLocaleString('pt-BR');
        //value = (parseFloat(value)).toString();
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        return value;
    }

    if (value.length > 3) {
        value = (parseFloat(value)).toLocaleString('pt-BR');
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
    }


    valor = value;

    return valor;
}

export const moedaRealLocaleValueEdit = (valor: string) => {
   
    if (valor === null) {
        return;
    }
    if (valor.length <= 1) {
        return valor;
    }


    let value = valor;

    if (Number(value) < 0) {
        value = (parseFloat(value)).toLocaleString('pt-BR');
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        return "-" + value;
    }

    if (Number.isInteger(Number(value))) {
        value = (parseFloat(value)).toLocaleString('pt-BR');
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        return value;
    }
    else if (Number(value)) {
        value = value.toString().replaceAll(".", ",");
        value = (parseFloat(value)).toLocaleString('pt-BR');
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        return value;
    }

    if (value.length > 3) {
        value = (parseFloat(value)).toLocaleString('pt-BR');
        // value = value.replace(/\D/g, "");
        // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
    }


    valor = value;

    return valor;
}

export const maskCep = (valor: string) => {
    if (valor === null) {
        return;
    }

    if (valor.length > 9) {
        return valor.substring(0, 8);
    }

    let value = valor;
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    valor = value;
    return valor;
}

export const maskDddCel = (valor: string) => {

    if (valor === null) {
        return;
    }
    if (valor.length > 2) {
        return valor.substring(0, 2);
    }

    let value = valor;
    value = value.replace(/\D/g, "");
    //value = value.replace(/\([1-9]{2}\)/, "$1-$2");
    value = value.replace(/^(\d{2})/, "$1");
    valor = value;

    return valor;
}

export const maskCelular = (valor: string) => {

    if (valor === null) {
        return;
    }

    if (valor !== null && valor.length > 9) {
        return valor.substring(0, 10);
    }

    let value = valor;
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{5})(\d{4})$/, "$1-$2");
    valor = value;

    return valor;
}



export const cep = (e: React.FormEvent<HTMLInputElement>) => {

    e.currentTarget.maxLength = 9;
    let value = e.currentTarget.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    e.currentTarget.value = value;
    return e;
}

export const currency = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    let value = e.target.value;
    value = (parseFloat(value)).toLocaleString('pt-BR');
    // value = value.toString().replace(/\D/g, "");
    // value = value.replace(/(\d)(\d{2})$/, "$1,$2");
    // value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
    e.currentTarget.value = value;


    return e;
}


function makeDecimal(num: number) {

    var leftDecimal = num.toString().replace('.', ''),
        rightDecimal = '00';

    if (leftDecimal.length > 2) {
        rightDecimal = leftDecimal.slice(-2);
        leftDecimal = leftDecimal.slice(0, -2);
    }

    var n = Number(leftDecimal + '.' + rightDecimal).toFixed(2);
    return (n === "NaN") ? num : n
}


export const mascara = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    var copia = e.target.value;
    
    var tam = copia.length;  
    var temp = '';  
    for (let i = (tam - 1); i >= 0; i--){  
        temp = copia.charAt(i) + temp;  
        if ((copia.substring(i).length % 3 == 0) && (i > 0)){  
            temp = '.' + temp;  
        }  
    }  

    e.currentTarget.value = temp;
    return e;
}


export const number = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    var copia = e.target.value;
    
    e.target.value = copia.toLocaleString();
    return e;
}